import script from "./NonGeneratePageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./NonGeneratePageHeader.vue?vue&type=script&setup=true&lang=js"

import "./NonGeneratePageHeader.vue?vue&type=style&index=0&id=4cc9eeda&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2503735441/src/recipe-ai-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cc9eeda"]])

export default __exports__